import React from 'react';
interface SectionHeadingProps {
  title: string;
  eyebrow?: string;
  description?: string;
  id?: string;
  size?: 'md' | 'lg';
}
export function SectionHeading({
  title,
  eyebrow,
  description,
  id,
  size = 'md'
}: SectionHeadingProps) {
  return <div className="mx-auto flex max-w-3xl flex-col items-center gap-1.5 text-center" data-id="element-192" data-mp="3f36rdlf93t87">
      {eyebrow && <p className="text-[0.62rem] font-extrabold uppercase tracking-[0.24em] text-coral sm:text-xs" data-id="element-193" data-mp="3k2025635l64o">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display font-black uppercase leading-[1.05] text-ink ${size === 'lg' ? 'text-xl sm:text-3xl lg:text-4xl' : 'text-lg sm:text-2xl lg:text-3xl'}`} data-id="element-194" data-mp="giex9unt95q1">
        {title}
      </h2>
      <span aria-hidden="true" className="h-1 w-12 rounded-full bg-gold" data-id="element-195" data-mp="ujhk49mmqk20" />
      {description && <p className="font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-196" data-mp="z9oaadwsicmd">
          {description}
        </p>}
    </div>;
}